import React, { useRef, useCallback } from 'react'
import _ from 'lodash'

import { useGlobalShortcut } from 'admin/lib/shortcuts'
import { Matchers } from 'admin/lib/Records'

import { Context } from './SectionContext'

export const SectionProvider = props => {
  /** @type {React.MutableRefObject<React.RefObject<HTMLElement>[]>} */
  const sections = useRef([])

  const register = useCallback(
    /** @param {React.RefObject<HTMLElement>} ref */
    ref => {
      sections.current = _([...sections.current, ref])
        .filter(ref => !!ref.current)
        .orderBy(ref => ref.current.getElement?.().offsetTop, 'asc')
        .value()

      return () => {
        sections.current = sections.current.filter(thisRef => thisRef !== ref)
      }
    },
    []
  )

  const handleFormSectionJump = useCallback(direction => {
    const all = sections.current.filter(
      ref => ref.current.getElement?.().getBoundingClientRect().height > 100
    )

    // Check if we're in a section already and jump +/-
    for (let i = 0; i < all.length; i++) {
      if (all[i].current.contains(document.activeElement)) {
        let nextIndex = i + direction
        if (nextIndex >= all.length) nextIndex = 0
        if (nextIndex < 0) nextIndex = all.length - 1
        all[nextIndex].current.focus()

        document.activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
        return
      }
    }

    // Default positions if we're not already placed in a section
    if (direction > 0) {
      all[0].current.focus()
    } else {
      all[all.length - 1].current.focus()
    }
  }, [])

  const handleFormJumpTop = useCallback(() => {
    document.getElementById('form-panel').scrollTop = 0
  }, [])

  useGlobalShortcut(
    Matchers.form.jumpDown,
    useCallback(() => handleFormSectionJump(1), [handleFormSectionJump])
  )

  useGlobalShortcut(
    Matchers.form.jumpUp,
    useCallback(() => handleFormSectionJump(-1), [handleFormSectionJump])
  )

  useGlobalShortcut(
    Matchers.form.jumpTop,
    useCallback(() => handleFormJumpTop(-1), [handleFormJumpTop])
  )

  useGlobalShortcut(
    Matchers.form.jumpBottom,
    useCallback(
      () => document.querySelector('.backToTopButton')?.scrollIntoView(),
      []
    )
  )

  return <Context.Provider {...props} value={register} />
}
